import axiosClient from 'api/config/axiosClient';

const getPrivacyPolicy = () => {
  const url = 'v1/privacy-policy';
  return axiosClient.get(url);
};

const updatePrivacyPolicy = (payload) => {
  const url = 'v1/privacy-policy';
  return axiosClient.put(url, payload);
};

export { getPrivacyPolicy, updatePrivacyPolicy };
